import seguimiento from './seguimiento';
import maestros from './maestros';
import secretaria from './secretaria';
import administracion from './administracion';
import almacen from './almacen';
import ventas from './ventas';
import bodegas from './bodegas';
import viticultores from './viticultores';
import utilities from './utilities';
import other from './other';
import { useSelector } from 'react-redux';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = auth => {
    if (auth.user.roles.some(role => role.id === 'Bodega'))
        return { items: [bodegas] };

    if (auth.user.roles.some(role => role.id === 'Viticultor'))
        return { items: [viticultores] };

    return {
        items: [
            seguimiento,
            maestros,
            almacen,
            ventas,
            administracion,
            secretaria
        ]
    };
};

const applyPermissions = auth => {
    const items = menuItems(auth);

    return items;
};

export const createMenuItems = auth => {
    if (!auth.user) return null;
    return applyPermissions(auth);
};
